import clsx from 'clsx'
import update from 'immutability-helper'
import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import DialogContentText from '@mui/material/DialogContentText'
import TextInput from '../../text-input'
import Dialog from '../../responsive-fullscreen-dialog'
import create from '../../../helpers/command'

export default function DirectoryRowSettings ({selected, directory, context, classes, assessments, shared, onEditNameClick}) {
  const {translate} = context
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [deleteOpened, openDeleteDirectory] = React.useState(false)
  const canShare = assessments.length > 0

  const openRowSettingsMenu = (e) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }

  const closeRowSettingsMenu = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
  }

  function handleOpenDelete(e) {
    closeRowSettingsMenu(e)
    openDeleteDirectory(true)
  }

  async function handleDelete(e) {
    e.stopPropagation()
    openDeleteDirectory(false)
    const [{id: deletedId}] = (await create('quiz', 'deleteDirectory')({id: directory.id})) || [{}]
    if (deletedId == directory.id) {
      const quizDirectories = update(context.quizDirectories, {$unset : [deletedId]})
      context.setState({quizDirectories, quizAssessmentCalls: context.quizAssessmentCalls + 1})
    }
  }

  async function handleShare (e) {
    closeRowSettingsMenu(e)
    const [sharedId] = await create('quiz', 'shareDirectory')({id: directory.id, shared: !shared})
    if (sharedId == directory.id) {
      context.setState({quizAssessmentCalls: context.quizAssessmentCalls + 1})
    }
  }

  function handleRename(e) {
    closeRowSettingsMenu(e)
    e.stopPropagation()
    if (onEditNameClick) onEditNameClick()
  }

  function handleCloseDelete (e) {
    e.stopPropagation()
    openDeleteDirectory(false)
  }

  return (
    <Box className={classes.moreSettings} onClick={e => e.stopPropagation()}>
      <Box className={clsx(classes.moreSettingsButton, {selected})} onClick={openRowSettingsMenu}>
        <MoreVertIcon />
      </Box>
        <Menu
          id="settings-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={closeRowSettingsMenu}
        >
          <MenuItem onClick={handleRename}>{context.translate('rename')}</MenuItem>
          {canShare && <MenuItem onClick={handleShare}>{context.translate(shared ? 'unshare' : 'share')}</MenuItem>}
          <MenuItem onClick={handleOpenDelete}>{context.translate('delete')}</MenuItem>
        </Menu>
      <Dialog
        open={deleteOpened}
        close={handleCloseDelete}
        confirm={<Button variant="contained" color="primary" onClick={handleDelete}>{translate('delete')}</Button>}
        cancel={<Button variant="contained" color="secondary" onClick={handleCloseDelete}>{translate('cancel')}</Button>}
        title={translate('confirm_delete_item')}
      >
        <DialogContentText>
          {translate('delete-directory-message', directory)}
        </DialogContentText>
      </Dialog>
    </Box>
  )
}
